import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { RouteEnum } from './routeConstants';
import Login from '../pages/login/Login';
import Dashboard from '../pages/dashboard/Dashboard';
import Transactions from '../pages/transactions/Transactions';
import ProtectedRoute from './ProtectedRoute';
import Redirecting from '../components/redirecting/Redirecting';
import Details from '../pages/details/Details';
import UpdateTicket from '../pages/edit/UpdateTicket';
import AppLayout from '../components/applayout/AppLayout';
import Rawdata from '../pages/transactions/Rawdata';
import RawDetails from '../pages/details/RawDetails';
import CorrectTicket from '../pages/correction/CorrectTicket';
import MiConfiguration from '../pages/miconfiguration/MiConfiguration';
import Admin from '../pages/admin/Admin';
import Signout from '../components/redirecting/Signout';
import ConfigureReport from '../pages/report/ConfigureReport';
import ConfigureReportList from '../pages/report/ConfigureReportList';
import GenerateReport from '../pages/report/GenerateReport';
import ViewReport from '../pages/report/ViewReport';



const NotFound = () => <h1>Page Not Found</h1>;

const Approutes = () => {
    return (
        <Router>
            <div>
                <Routes>
                    <Route  path={RouteEnum.root} element={<Login />} />


                    <Route  path={RouteEnum.root} element={<AppLayout/>} >
                        <Route  path={RouteEnum.dashboard} element={<ProtectedRoute element={<Dashboard />} pageName='Dashboard'/>} /> 
                        <Route  path={RouteEnum.transactions} element={<ProtectedRoute element={<Transactions />} pageName='MI'/>} />
                        <Route  path={RouteEnum.details} element={<ProtectedRoute element={<Details/>} pageName='MI'/>} /> 
                        <Route  path={RouteEnum.updateTicket} element={<ProtectedRoute element={<UpdateTicket/>} pageName='Update Ticket'/>} /> 

                        <Route  path={RouteEnum.rawdata} element={<ProtectedRoute element={<Rawdata />} pageName='All transactions'/>} /> 
                        <Route  path={RouteEnum.rawtransaction} element={<ProtectedRoute element={<RawDetails />} pageName='All transactions'/>} /> 
                        <Route  path={RouteEnum.correctTransaction} element={<ProtectedRoute element={<CorrectTicket/>} pageName='Correct Ticket'/>} /> 
                        <Route  path={RouteEnum.admin} element={<ProtectedRoute element={<Admin />} pageName='Admin'/>} /> 
                        <Route  path={RouteEnum.miconfiguration} element={<ProtectedRoute element={<MiConfiguration />} pageName='MI Configuration'/>} /> 
                        <Route  path={RouteEnum.reportList} element={<ProtectedRoute element={<ConfigureReportList />} pageName='Reports'/>} /> 
                        <Route  path={RouteEnum.configureReportNew} element={<ProtectedRoute element={<ConfigureReport />} pageName='Reports'/>} /> 
                        <Route  path={RouteEnum.configureReportEdit} element={<ProtectedRoute element={<ConfigureReport />} pageName='Reports'/>} /> 
                        <Route  path={RouteEnum.viewReport} element={<ProtectedRoute element={<ViewReport />} pageName='Reports'/>} /> 
                        <Route  path={RouteEnum.generateReport} element={<ProtectedRoute element={<GenerateReport />} pageName='Reports'/>} /> 
                        
                    </Route>

                    <Route  path={RouteEnum.notfound} element={<NotFound />} />

                    <Route  path={RouteEnum.redirecting} element={<Redirecting />} />
                    <Route  path={RouteEnum.signout} element={<Signout />} />
                </Routes>
            </div>
        </Router>
    );
};

export default Approutes;